import styled from 'styled-components';

export const MobileDropdownMenuSubSectionLinks = styled.ul`
    padding: 0px;
    list-style-type: none;
    list-style-position: outside;
    margin: 0;
`;
